module.exports = __webpack_public_path__ + "img/general_attestations.823d77ec.svg";